import instance from '../index';
import { COMEINURL } from '@/jmHttp/host';
import { market, performance, analyst, roadshow, articlecenter, industry } from '../interface';

//公告列表
export const queryAnnouncementAllPage = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/announcement/list/all`, data, config);
};
//获取指定个股的重大公告列表
export const queryImportAnnouncementList = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/announcement/list/import`, data, config);
};
//获取指定个股的业绩公告列表
export const queryPerformanceAnnouncementList = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/announcement/list/earnings`, data, config);
};
//获取指定个股的公告分类
export const queryAnnouncementCategory = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/announcement/list/category`, data, config);
};
//获取指定个股的分类公告列表
export const queryAnnouncementByPid = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/announcement/list/listByPid`, data, config);
};
// 获取个股纪要的研究详情
export const querySummaryList = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/announcement/list/investor-rel`, data, config);
};
// 个股
export const individualShare = async (data, config = {}) => {
  return instance.post(market.individualShare, data, config);
};
// 个股-报告期列表
export const fiscalYearList = async (data, config = {}) => {
  return instance.post(market.fiscalYearList, data, config);
};
// 个股-业绩期列表
export const earningsPeriodList = async (data, config = {}) => {
  return instance.post(market.earningsPeriodList, data, config);
};
// 公司业绩-财务时间
export const financeTime = async (data, config = {}) => {
  return instance.post(performance.financeTime, data, config);
};
// 公司业绩-业绩报告列表
export const stockFinancialReportList = async (data, config = {}) => {
  return instance.post(performance.stockFinancialReportList, data, config);
};
// 公司业绩-最新业绩预报
export const latestForecast = async (data, config = {}) => {
  return instance.post(performance.latestForecast, data, config);
};
// 公司业绩-路演
export const roadShowStock = async (data, config = {}) => {
  return instance.post(performance.roadShowStock, data, config);
};
// 公司业绩-纪要
export const summaryStock = async (data, config = {}) => {
  return instance.post(performance.summaryStock, data, config);
};

// 推广活动列表
export const roadShowMeetingList = async (data, config = {}) => {
  return instance.post(performance.meetingList, data, config);
};

// 路演业绩日历
export const roadshowCalendarList = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/json/stock-financial-report/earnings-roadshow-calendar-list`, data, {
    noChangeFormat: true,
    ...config
  });
};

// 业绩披露日历
export const reportCalendarList = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/json/stock-financial-report/earnings-report-calendar-list`, data, {
    noChangeFormat: true,
    ...config
  });
};

// 路演业绩日历(日、列表视图)
export const reportCalendarListDay = async (data, config = {}) => {
  return await instance.post(`${COMEINURL}/brm/json/stock-financial-report/earnings-report-calendar-list-view`, data, {
    noChangeFormat: true,
    ...config
  });
};

// 路演业绩日历列表(日、列表视图)
export const roadshowAllListDay = async (data, config = {}) => {
  return await instance.post(
    `${COMEINURL}/brm/json/stock-financial-report/earnings-meetingactivity-calendar-list-view`,
    data,
    {
      noChangeFormat: true,
      ...config
    }
  );
};

// 路演业绩日历(月视图)
export const roadshowCalendarListMonth = async (data, config = {}) => {
  return await instance.post(
    `${COMEINURL}/brm/json/stock-financial-report/earnings-roadshow-calendar-list-specified`,
    data,
    {
      noChangeFormat: true,
      ...config
    }
  );
};

// 业绩披露日历(月视图)
export const reportCalendarListMonth = async (data, config = {}) => {
  return await instance.post(
    `${COMEINURL}/brm/json/stock-financial-report/earnings-report-calendar-list-specified`,
    data,
    {
      noChangeFormat: true,
      ...config
    }
  );
};

// 路演业绩日历列表
export const roadshowAllList = async (data, config = {}) => {
  return await instance.post(
    `${COMEINURL}/brm/json/stock-financial-report/earnings-meetingactivity-calendar-list`,
    data,
    {
      noChangeFormat: true,
      ...config
    }
  );
};

// 进门热点
export const queryTrendingStockList = async (data, config = {}) => {
  return instance.post(market.trendingStockList, data, config);
};
// K线数据月、周、日
export const queryMarketQuotations = async (data, config = {}) => {
  return instance.post(market.marketQuotations, data, config);
};

// 分钟 K 线 / 分时图
export const queryStockRealtimeKlineHistory = async (data, config = {}) => {
  return instance.post(market.stockRealtimeKlineHistory, data, config);
};

// 调研纪要列表(个股详情页)
export const querySummaryQueryPage = async (data, config = {}) => {
  return await instance.post(market.researchSummaryList, data, config);
};

//研报中心搜索查询
export const queryReportSearch = async (data, config = {}) => {
  return await instance.post(market.reportSearch, data, config);
};

//近期活动-路演列表接口（上市公司相关业绩发布）
export const queryPerformanceRoadshowList = async (data, config = {}) => {
  return await instance.post(roadshow.performanceList, data, config);
};

//近期活动-路演列表接口（行业相关业绩发布）
export const queryIndustryPerformanceRoadshowList = async (data, config = {}) => {
  return await instance.post(roadshow.industryPerformanceList, data, config);
};

//获取个股财务指标接口-新
export const queryFinanceIndexDetailNew = async (data, config = {}) => {
  return await instance.post(market.financeDetail, data, config);
};

//公司概况
export const companyProfile = async (data, config = {}) => {
  return await instance.post(market.companyProfile, data, config);
};

//获取个股关注分析师列表
export const queryStockAttentionAnalyst = async (data, config = {}) => {
  return await instance.post(analyst.stockAttentionAnalyst, data, config);
};

//行业-路演列表
export const industryRoadshowList = async (data, config = {}) => {
  return await instance.post(roadshow.allRoadshow, data, config);
};

//题材-路演列表
export const themeRoadshowList = async (data, config = {}) => {
  return await instance.post(roadshow.themeRoadshow, data, config);
};

// 用户行业浏览信息
export const industryUserBrowseList = async (data, config = {}) => {
  return await instance.post(industry.industryBrowseList, data, config);
};

// 获取用户关注行业
export const userIndustryInfo = async (data, config = {}) => {
  return await instance.post(industry.followIndustryTradeInfo, data, config);
};

// 当前最大交易日期时间-个股
export const stockTradeDay = async (data, config = {}) => {
  return await instance.post(market.stockTradeDay, data, config);
};

//热门产业链
export const queryIndustrialChainHotList = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainHotList, data, config);
};

//自选产业链
export const queryIndustrialChainFollowList = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainFollowList, data, config);
};

//产业链搜索
export const queryIndustrialChainSearch = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainSearch, data, config);
};

//产业链最近浏览
export const queryIndustrialChainListBrowse = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainListBrowse, data, config);
};

//产业链详情
export const queryIndustrialChainDetail = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainDetail, data, config);
};

//产业链个股列表
export const queryIndustrialChainStockList = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainStockList, data, config);
};

//产业链个股基本面
export const queryIndustrialChainStockFundmentals = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainStockFundmentals, data, config);
};

//产业链图谱
export const queryIndustrialChainGraph = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainGraph, data, config);
};

//产品题材构成图谱
export const queryIndustrialChainThemeConstituteList = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainThemeConstituteList, data, config);
};

//产品行情累计涨跌幅
export const queryIndustrialChainTotalChangePct = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainTotalChangePct, data, config);
};

//产品排序
export const queryIndustrialChainSort = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainSort, data, config);
};

//产品置顶置底
export const queryIndustrialChainPin = async (data, config = {}) => {
  return await instance.post(market.queryIndustrialChainPin, data, config);
};

//关注专题、行业、券商，股票操作
export const subscriptionOperate = async (data, config = {}) => {
  return await instance.post(market.subscriptionOperate, data, config);
};

// 获取个股全量交易数据列别
export const queryStockTradeAllList = async (data, config = {}) => {
  return await instance.post(market.stockClosePriceList, data, config);
};

//获取指数行情列表
export const queryTradeDataList = async (data, config = {}) => {
  return await instance.post(market.queryTradeDataList, data, config);
};

//获取个股每日交易统计列表-新
export const queryStockStatisticsDaily = async (data, config = {}) => {
  return await instance.post(market.stockCountDaily, data, config);
};

//获取个股每周交易统计列表-新
export const queryStockStatisticsWeekly = async (data, config = {}) => {
  return await instance.post(market.stockCountWeekly, data, config);
};

//获取个股每月交易统计列表-新
export const queryStockStatisticsMonthly = async (data, config = {}) => {
  return await instance.post(market.stockCountMonthly, data, config);
};

/** 获取 K 线打点（日/周/月统一接口） */
export const queryStockKlineCountList = async (data, config = {}) => {
  return await instance.post(market.stockCountKlineList, data, config);
};

//获取分析师用户的路演列表（用户作为主讲人或嘉宾）
export const stockAnalystRoadshowList = async (data, config = {}) => {
  return await instance.post(analyst.stockAnalystRoadshowList, data, config);
};

//获取分析师用户的研报列表
export const stockAnalystResearchList = async (data, config = {}) => {
  return await instance.post(analyst.stockAnalystResearchList, data, config);
};

//获取个股下的分析师列表（分页）
export const stockAnalystList = async (data, config = {}) => {
  return await instance.post(analyst.stockAnalystList, data, config);
};

//分析师总览数据
export const stockAnalystOverview = async (data, config = {}) => {
  return await instance.post(analyst.stockAnalystOverview, data, config);
};

//分析师业务类型统计打点数据
export const stockAnalystCountByType = async (data, config = {}) => {
  return await instance.post(analyst.stockAnalystCountByType, data, config);
};

//分析师打点数据
export const stockAnalystALlBizCountList = async (data, config = {}) => {
  return await instance.post(analyst.stockAnalystALlBizCountList, data, config);
};

// 分组概览
export const stockGroupOverview = async (data, config = {}) => {
  return await instance.post(articlecenter.stockGroupOverview, data, config);
};

// 分组概览-研报列表
export const stockGroupReportList = async (data, config = {}) => {
  return await instance.post(articlecenter.stockGroupReportList, data, config);
};

// 分组概览-调研列表
export const stockGroupResearchList = async (data, config = {}) => {
  return await instance.post(articlecenter.stockGroupResearchList, data, config);
};

// 分组概览-路演列表
export const stockGroupRoadshowList = async (data, config = {}) => {
  return await instance.post(articlecenter.stockGroupRoadshowList, data, config);
};

// 会议活动列表
export const meetingActivityRoadShowList = async (data, config = {}) => {
  return await instance.post(articlecenter.meetingActivityList, data, config);
};

// 自助会议 活动-路演-推荐-自选 列表（自助会议）
export const stockGroupRoadshowMeetList = async (data, config = {}) => {
  return await instance.post(articlecenter.stockGroupRoadshowMeetList, data, config);
};

// 分组概览-业绩公告列表
export const stockGroupEarningsList = async (data, config = {}) => {
  return await instance.post(articlecenter.stockGroupEarningsList, data, config);
};

// 分组概览-全部公告列表
export const stockGroupAnnouncementsList = async (data, config = {}) => {
  return await instance.post(articlecenter.stockGroupAnnouncementsList, data, config);
};

// 分组概览-资讯列表
export const stockGroupNewsList = async (data, config = {}) => {
  return await instance.post(articlecenter.stockGroupNewsList, data, config);
};

// 业绩期小提琴图
export const stockFdViolin = async (data, config = {}) => {
  return await instance.post(performance.stockFdViolin, data, config);
};

// 业绩期盒须图
export const stockFdBoxplot = async (data, config = {}) => {
  return await instance.post(performance.stockFdBoxplot, data, config);
};

// 业绩期财务时间
export const reportFinanceTime = async (data, config = {}) => {
  return await instance.post(performance.reportFinanceTime, data, config);
};

// 业绩时间轴
export const reportTimeLine = async (data, config = {}) => {
  return await instance.post(performance.reportTimeLine, data, config);
};

// 业绩历史财务数据
export const reportFinancialHistoryList = async (data, config = {}) => {
  return await instance.post(performance.reportFinancialHistoryList, data, config);
};

// 业绩历史业绩兑现
export const forecastVsActual = async (data, config = {}) => {
  return await instance.post(performance.forecastVsActual, data, config);
};

// 业绩盈利预测
export const forecastProfit = async (data, config = {}) => {
  return await instance.post(performance.forecastProfit, data, config);
};

// 业绩盈利明细
export const forecastProfitDetail = async (data, config = {}) => {
  return await instance.post(performance.forecastProfitDetail, data, config);
};

// 业绩盈利一致预测变化
export const forecastProfitChange = async (data, config = {}) => {
  return await instance.post(performance.forecastProfitChange, data, config);
};

// 业绩预测机构列表
export const getOrganizationList = async (data, config = {}) => {
  return await instance.post(performance.queryOrganizationList, data, config);
};

// 业绩预测年份
export const getForecastYear = async (data, config = {}) => {
  return await instance.post(performance.queryForecastYear, data, config);
};

// 超预期列表
export const reportExceedingList = async (data, config = {}) => {
  return await instance.post(performance.reportExceedingList, data, config);
};

// 披露比例
export const financialDisclosureRate = async (data, config = {}) => {
  return await instance.post(performance.financialDisclosureRate, data, config);
};

// 最新业绩预报
export const reportLetestForecast = async (data, config = {}) => {
  return await instance.post(performance.reportLetestForecast, data, config);
};

// 公告列表查询
export const reportQueryAnnouncement = async (data, config = {}) => {
  return await instance.post(performance.reportQueryAnnouncement, data, config);
};

// 是否处于静默期
export const isInQuietPeriod = async (data, config = {}) => {
  return await instance.post(performance.isInQuietPeriod, data, config);
};

// 是否为ST
export const isST = async (data, config = {}) => {
  return await instance.post(performance.isST, data, config);
};

// 获取最新财报
export const latestReport = async (data, config = {}) => {
  return await instance.post(performance.latestReport, data, config);
};

// 分组概览-业绩日历
export const earningsCalendarList = async (data, config = {}) => {
  return await instance.post(articlecenter.earningsCalendarList, data, {
    noChangeFormat: true,
    ...config
  });
};

// 财报业绩日历按天统计
export const countEarningsReportCalendar = async (data, config = {}) => {
  return await instance.post(articlecenter.countEarningsReportCalendar, data, config);
};

// 业绩路演日历按天统计
export const countEarningsRoadshowCalendar = async (data, config = {}) => {
  return await instance.post(articlecenter.countEarningsRoadshowCalendar, data, config);
};

//推广活动业绩日历按天统计数量
export const meetingActivityCalendar = async (data, config = {}) => {
  return await instance.post(articlecenter.meetingActivityCalendar, data, config);
};

// 获取指数表现数据
export const getIndexPerformance = async (data, config = {}) => {
  return await instance.post(industry.getIndexPerformance, data, config);
};

// 获取行业表现
export const getIndustryPerformance = async (data, config = {}) => {
  return await instance.post(industry.getIndustryPerformance, data, config);
};

// 获取行业拥挤度
export const getIndustryCrowded = async (data, config = {}) => {
  return await instance.post(industry.getIndustryCrowded, data, config);
};

// 日涨跌
export const getDailyRiseFall = async (data, config = {}) => {
  return await instance.post(industry.getDailyRiseFall, data, config);
};

// PE
export const getPe = async (data, config = {}) => {
  return await instance.post(industry.getPe, data, config);
};

//跌涨前十
export const industryTopTen = async (data, config = {}) => {
  return await instance.post(industry.topDownTenStock, data, config);
};

//根据行业级别获取行业交易信息
export const industryTradeInfo = async (data, config = {}) => {
  return await instance.post(industry.industryTradeInfo, data, config);
};

// 按天统计场次
export const roadshowStaticDays = async (data, config = {}) => {
  return await instance.post(industry.roadshowStaticDays, data, config);
};

// 行业每日收盘价
export const industryDailyClose = async (data, config = {}) => {
  return await instance.post(industry.industryDailyClose, data, config);
};

// 行业行为
export const industryBehavior = async (data, config = {}) => {
  return await instance.post(industry.industryBehavior, data, config);
};

export const getRangePercentageChangeList = async (data, config = {}) => {
  return await instance.post(industry.getRangePercentageChangeList, data, config);
};

//行业公司热度
export const getIndustryCompanyHotList = async (data, config = {}) => {
  return await instance.post(industry.getIndustryCompanyHotList, data, config);
};

//成分股
export const getStockTradeData = async (data, config = {}) => {
  return await instance.post(industry.getStockTradeData, data, config);
};

// 行业下的业绩前top的公司
export const performanceTopCompany = async (data, config = {}) => {
  return await instance.post(industry.performanceTopCompany, data, config);
};

// 根据输入解析行业
export const findIndustryByInput = async (data, config = {}) => {
  return await instance.post(industry.findIndustryByInput, data, config);
};

//行业详情
export const queryIndustryInfo = async (data, config = {}) => {
  return await instance.post(industry.industryInfo, data, config);
};

// 获取用户关注行业
export const getIndustryFollow = async (data, config = {}) => {
  return await instance.post(industry.industryFollow, data, config);
};

// 获取不同市场行业列表
export const industryList = async (data, config = {}) => {
  return await instance.post(industry.industryList, data, config);
};

// 合作调研纪要
export const researchSummaryListThird = async (data, config = {}) => {
  return await instance.post(market.researchSummaryListThird, data, config);
};

// 合作调研纪要详情
export const researchSummaryDetailThird = async (data, config = {}) => {
  return await instance.post(market.researchSummaryDetailThird, data, config);
};

// 根据初级行业获取一级行业
export const getFirstIndustryBySuperId = async (data, config = {}) => {
  return await instance.post(industry.getFirstIndustryBySuperId, data, config);
};

/**
 * 按股票全码批量查询行情
 * @param {*} data
 * @param {*} config
 * @returns
 */
export const queryStockRealtime = async (data, config = {}) => {
  return await instance.post(market.queryStockRealtime, data, config);
};
